import React from 'react';
import { Card } from '@theme-ui/components';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import { Link as ExternalLink } from '@theme-ui/components';

const CardLink = ({ url, children }) => {
  if (url) {
    const isExternalLink = url.startsWith('http');
    return (
      <>
        {isExternalLink ? (
          <ExternalLink href={url} target='_blank'>
            {children}
          </ExternalLink>
        ) : (
          <Link to={url}>{children}</Link>
        )}
      </>
    );
  } else {
    return <>{children}</>;
  }
};

const SocialLinkCard = ({ image, alt, title, url }) => (
  <CardLink url={url}>
    <Card variant='primary'>
      <GatsbyImage
        image={image.gatsbyImageData}
        imgStyle={{ width: '100%', height: '100%', objectFit: 'contain' }}
        alt={alt}
        title={title}
      />
    </Card>
  </CardLink>
);

export default SocialLinkCard;
